import React, { useEffect, useRef, useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Box,
} from "@chakra-ui/react";
import {Col,Form,Row} from "react-bootstrap";
import axios from 'axios';
import { useDispatch } from "react-redux";
import { useToasts } from "react-toast-notifications";
import { fetchAsyncAddEmbrillProfile } from "redux/embrillProfileSlice";
import { fetchAsyncUpdateEmbrillProfile } from "redux/embrillProfileSlice";
import ExcelComponent from "./excelComponent";
import { fetchAsyncUploadExcel } from "redux/embrillProfileSlice";
import { fetchAsyncDeleteExcel } from "redux/embrillProfileSlice";
import { FaPlusCircle } from "react-icons/fa";
import SpinnerLoader from "components/Spinner/SpinnerLoader";
import commonJson from "components/jsonData/common.json";
import orgJson from "components/jsonData/orgnization.json";
import ConfirmationDialog from "components/sweetAlert.js/ConfirmationDialog";
import { ACCOUNT_NUMBER_REGEX, EMAIL_REGEX, IFSC_REGEX, MAX_IFSC_LENGTH, PHONE_REGEX, SWIFT_REGEX } from "../regexPatterns";
import InputFormControl from "../component/inputFormControl";
import SubmitButton from "../component/buttons/submitButton";

const OrganizationBankForm = ({
  openModal,
  closeModal,
  isEditForm = false,
  editItem,
  role
}) => {
  const finalRef = useRef(null);

  const [formData, setFormData] = useState({
    contactPerson: '',
    email: '',
    phone: '',
    bankName: '',
    branchName: '',
    ifscCode: '',
    swiftCode: '',
    aliasName: '',
    isPrimary: false,
    accountNumber: '',
  });

  const [excelData, setExcelData] = useState([])

  const [errors, setErrors] = useState({});
  const [editData, setEditData] = useState(editItem)
  const [isEdit, setIsEdit] = useState(isEditForm)
  const dispatch = useDispatch();
  const { addToast } = useToasts();

  const [isLoading, setIsLoading] = useState(false); 


  const addExcelDetail = () => {
    setExcelData((prev) => ([
        ...prev,
        {
         typId:null,
         file:""
        },
      ]
   ));
  };


  useEffect(()=>{
    if(editData){
      setFormData({
      contactPerson: editData?.cnctPsn || "",
      email: editData?.mail || "",
      phone: editData?.ph || "",
      accountNumber: editData?.acNo || "",
      ifscCode: editData?.ifc || "",
      swiftCode: editData?.swiftCode || "",
      aliasName: editData?.aliasName || "",
      isPrimary: editData?.isPrimary||false,
      bankName: editData?.bnk || "",
      branchName: editData?.bch || "",
    })
    if(editData?.exDts){
      setExcelData(editData?.exDts)
    }
    }
  },[editData])

  const validate = () => {
    const newErrors = {};
       
    if (formData.email && !EMAIL_REGEX.test(formData.email)) {
      newErrors.email = orgJson.error.email;
    }
    if (formData.phone  && !PHONE_REGEX.test(formData.phone)) {
      newErrors.phone = orgJson.error.phone;
    }
    
    if (!formData.accountNumber) {
      newErrors.accountNumber = orgJson.required.accNumber;
    } else if (!ACCOUNT_NUMBER_REGEX.test(formData.accountNumber)) {
      newErrors.accountNumber = orgJson.error.accNumber;
    }

    if (!formData.aliasName) {
      newErrors.aliasName = orgJson.required.aliasName;
    }

    if (!formData.ifscCode) {
      newErrors.ifscCode = orgJson.required.ifsc;
    } else if (!IFSC_REGEX.test(formData.ifscCode)) {
      newErrors.ifscCode = orgJson.error.ifsc;
    }

    if (formData.swiftCode && !SWIFT_REGEX.test(formData.swiftCode)) {
      newErrors.swiftCode = orgJson.error.swift;
    }

    

    setErrors(newErrors);
    
    return Object.keys(newErrors).length === 0;
  };

  const toCamelCase = (value) => {
    return value
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    let formattedValue = value;

    if (["panNo","gstNo","ifscCode", 'swiftCode'].includes(name)) {
      formattedValue = value.toUpperCase();
      if(name === "ifscCode" &&  formattedValue.length > MAX_IFSC_LENGTH ) {
        return 
      }
    } else if (name === "email") {
      formattedValue = value.toLowerCase(); 
    } else if(!["branchName",'bankName','accountNumber', 'aliasName'].includes(name)){
      formattedValue = toCamelCase(value); 
    }
    

    if (name === "phone") {
      if (!formattedValue || PHONE_REGEX.test(formattedValue)) {
        setErrors((prev) => ({ ...prev, phone: "" })); 
      } else {
        setErrors((prev) => ({ ...prev, phone: orgJson.error.phone }));
      }
    }
    if (name === "email") {
      if (!formattedValue || EMAIL_REGEX.test(formattedValue)) {
        setErrors((prev) => ({ ...prev, email: "" })); 
      }else{
        setErrors((prev) => ({ ...prev, email: orgJson.error.email })); 
      }
    }
   
    if (name === "ifscCode") {
      if (!formattedValue || IFSC_REGEX.test(formattedValue)) {
        setErrors((prev) => ({ ...prev, ifscCode: "" })); 
      } 
      else{
        setErrors((prev) => ({ ...prev, ifscCode: orgJson.error.ifsc })); 
      }
    }
    if (name === "accountNumber") {
      if (!formattedValue || ACCOUNT_NUMBER_REGEX.test(formattedValue)) {
        setErrors((prev) => ({ ...prev, accountNumber: "" })); 
      } 
      else{
        setErrors((prev) => ({ ...prev, accountNumber: orgJson.error.accNumber })); 
      }
    }

      setFormData((prev) => ({
        ...prev,
        [name]: formattedValue,
      }));
    
  };

  const handleConfirmPrimaryChange = (e) => {
    ConfirmationDialog({
      title: orgJson.confirm.togglePrimary,
      text: orgJson.text.togglePrimary,
      icon: "warning",
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
      onConfirm: () => {
        handleToggleCheckbox(e)
      },
    });
  }

  const handleToggleCheckbox = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: !e.target.checked
    }))
  }

  
  const fetchBranchDetails = async () => {
    const { ifscCode, micrCode } = formData;
    const codeToFetch = ifscCode || micrCode;
    if (!codeToFetch) return;

    try {
      const response = await axios.get(`https://ifsc.razorpay.com/${codeToFetch}`);
      const { BANK, BRANCH } = response.data;

      setFormData((prev) => ({
        ...prev,
        bankName: BANK,
        branchName: BRANCH,
      }));
    } catch (error) {
      setFormData((prev) => ({
        ...prev,
        bankName: "",
        branchName: "",
      }));
    }
  };

  const handleBlur = () => {
    if (IFSC_REGEX.test(formData.ifscCode)) {
      fetchBranchDetails();
    } else {
      setFormData((prev) => ({
        ...prev,
        bankName: "",
        branchName: "",
        
      }));
    }
  };

  const handleSwiftBlur = () => {
    if (formData.swiftCode && !SWIFT_REGEX.test(formData.swiftCode)) {
      setFormData((prev) => ({
        ...prev,
      }));
    }
  };

  const handleAddVendor = (data)=>{
    fetchAsyncAddEmbrillProfile(data)
      .then((res) => {
        if (res?.embrillProfile) {
          const embrillProfileDetails = res?.embrillProfile;
          setFormData(embrillProfileDetails)
          addToast(orgJson.success.created, { appearance: "success" });
          setIsEdit(true)
          setEditData(embrillProfileDetails)
          closeModal();
         }
  
      })
      .catch((err) => {
        addToast(err?.message || orgJson.error.generic, { appearance: "error" });
      });
  }
  const handleUpdateVendor = (data)=>{
    fetchAsyncUpdateEmbrillProfile({id:editData?._id,data:data})
      .then((res) => {
        if (res?.embrillProfile) {
          addToast(orgJson.success.updated, { appearance: "success" });
          closeModal();
         }
  
      })
      .catch((err) => {
        console.error('update vendor',err)
        addToast(err?.message || orgJson.error.generic, { appearance: "error" });
      });
  }
  
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
     if(!isEdit){
      handleAddVendor(formData)
     }else{
      handleUpdateVendor(formData)
     }
    }
  };

  const closeModelForm = () => {
    ConfirmationDialog({
      title: commonJson.close.confirm,
      text: commonJson.text.lost,
      icon: "warning",
      confirmButtonText: "Close",
      cancelButtonText: "Cancel",
      onConfirm: () => {
        closeModal();
      },
    });
  };

  const addNewExcelOnEdit = (file, index) => {
    ConfirmationDialog({
      title: orgJson.confirm.uploade,
      text: `Upload - ${file.name}`,
      icon: "warning",
      confirmButtonText: "Submit",
      cancelButtonText: "Cancel",
      onConfirm: () => {
        setIsLoading(true)
        if (editData) {
        
          let formData = new FormData();
          formData.append("excelTypeId", excelData[index]?.typId);

          formData.append("index", index);
          formData.append("file", file);
          formData.append("accountNumber", formData?.accountNumber || editData?.acNo);

          dispatch(
            fetchAsyncUploadExcel({ id: editData._id, formData })
          ).then((res) => {
            if(res?.payload){
              const newExcelData = res?.payload?.embrillProfile?.exDts
              setExcelData(newExcelData)
              setIsLoading(false)
              addToast(orgJson.success.uploaded, { appearance: "success" });

            }
            else{
              setIsLoading(false)
              addToast(orgJson.error.generic, { appearance: "error" });

            }
          }).catch((err)=>{
            setIsLoading(false)
            addToast(orgJson.error.generic, { appearance: "error" });

          })
        }
      },
    });
  };

  const handleExcelFile=(file,index)=>{
    const newExcelData = [...excelData];
    newExcelData[index].file = file;
    setExcelData(newExcelData);
  }

  const handleExcelType=(type,index)=>{
    setExcelData(prevExcelData => {
      const newExcelData = [...prevExcelData];
      newExcelData[index] = {
          ...newExcelData[index],
          typId: type.id
      };
      return newExcelData;
  });
  }
  const handleDeleteExcelOnEdit = (key,spId,index) => {
    ConfirmationDialog({
      title: orgJson.confirm.deleteFile,
      text: `Delete File ${key}`,
      icon: "warning",
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
      onConfirm: () => {
        setIsLoading(true)
        const sendData = {
          id: editData._id,
          key: key,
          index:index,
          spId:spId || ""
        };
        dispatch(fetchAsyncDeleteExcel(sendData)).then((res) => {
          const newExcelData = res?.payload?.embrillProfile?.exDts
          setExcelData(newExcelData);
          setIsLoading(false)
          addToast(orgJson.success.fileDeleted, { appearance: "success" });

        }).catch((err)=>{
          setIsLoading(false)
          addToast(orgJson.error.generic, { appearance: "error" });
        })
      },
    });
  };


  const handleDelete = (index)=>{
    setExcelData((prev) => (prev.filter((excel, i) => i !== index)
    ));
  }

  return (
    <>
      <Modal
        finalFocusRef={finalRef}
        isOpen={openModal}
        onClose={closeModelForm}
        size="xl"
      >
        <ModalOverlay />
        <ModalContent
          top="0"
          margin="0 auto"
          bottom="0"
          className="add-form-modal-content"
        >
          <div className="fixed-header">
            <ModalHeader className="expense-modal-header">
              {isEditForm ? "Edit" : "Add"} Bank Details
            </ModalHeader>
            <ModalCloseButton />
          </div>
          {isLoading ? (
            <SpinnerLoader />
          ) : (
            <ModalBody>
              <Form className="addForm">
                <div className="form-card">
                  <h5>Bank Details</h5>
                  <Row>
                    <Col>
                      <Box display="flex" className="input-box">
                        <Form.Label>Bank Alias Name <span className="span-star">*</span></Form.Label>
                        <InputFormControl
                          name="aliasName"
                          placeholder="Enter Bank Alias Name"
                          value={formData.aliasName}
                          handleChange={handleChange}
                          isInvalid={!!errors.aliasName}
                        />
                      </Box>
                      <p className="form_error"> {errors.aliasName}</p>
                    </Col>
                    <Col>
                      <Box display="flex" className="input-box">
                        <Form.Label>
                          Account Number <span className="span-star">*</span>
                        </Form.Label>
                        <InputFormControl
                          name="accountNumber"
                          placeholder="Enter Account Number"
                          value={formData.accountNumber}
                          handleChange={handleChange}
                          isInvalid={!!errors.accountNumber}
                        />
                      </Box>
                      <p className="form_error"> {errors.accountNumber}</p>
                    </Col>
                  </Row>
                  <Row>
                  <Col>
                      <Box display="flex" className="input-box">
                        <Form.Label>
                          IFSC Code <span className="span-star">*</span>
                        </Form.Label>
                        <InputFormControl
                          name="ifscCode"
                          placeholder="Enter IFSC Code"
                          value={formData.ifscCode}
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          isInvalid={!!errors.ifscCode}
                        />
                      </Box>
                      <p className="form_error"> {errors.ifscCode}</p>
                    </Col>
                    <Col>
                      <Box display="flex" className="input-box">
                        <Form.Label>Bank Name</Form.Label>
                        <InputFormControl
                          name="bankName"
                          placeholder="Enter Bank Name"
                          value={formData.bankName}
                          handleChange={handleChange}
                        />
                      </Box>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Box display="flex" className="input-box">
                        <Form.Label>Branch Name</Form.Label>
                        <InputFormControl
                          name="branchName"
                          placeholder="Enter Branch Name"
                          value={formData.branchName}
                          handleChange={handleChange}
                        />
                      </Box>
                    </Col>
                    <Col>
                      <Box display="flex" className="input-box">
                        <Form.Label>
                          SWIFT Code
                        </Form.Label>
                        <InputFormControl
                          name="swiftCode"
                          placeholder="Enter SWIFT Code"
                          value={formData.swiftCode}
                          handleChange={handleChange}
                          handleBlur={handleSwiftBlur}
                          isInvalid={!!errors.swiftCode}
                        />
                      </Box>
                      <p className="form_error"> {errors.swiftCode}</p>
                    </Col>
                  </Row>
                  <Row>
                    <Form.Check
                      id="isPrimary"
                      style={{marginLeft: '1rem'}}
                      type="checkbox"
                      name="isPrimary"
                      label="Set as Primary Bank"
                      checked={formData?.isPrimary}
                      onChange={handleConfirmPrimaryChange}
                    />
                  </Row>
                </div>
                <div className="form-card mt-3">
                  <h5>Bank Contact Person Details</h5>
                  <Row>
                    <Col>
                      <Box display="flex" className="input-box">
                        <Form.Label>Contact Person Name</Form.Label>
                        <InputFormControl
                          name="contactPerson"
                          placeholder="Enter Name"
                          value={formData.contactPerson}
                          handleChange={handleChange}
                        />
                      </Box>
                    </Col>
                    <Col></Col>
                  </Row>
                  <Row>
                    <Col>
                      <Box display="flex" className="input-box">
                        <Form.Label>Email</Form.Label>
                        <InputFormControl
                          name="email"
                          placeholder="Enter Email"
                          value={formData.email}
                          handleChange={handleChange}
                          isInvalid={!!errors.email}
                        />
                      </Box>
                      <p className="form_error">{errors.email}</p>
                    </Col>
                    <Col>
                      <Box display="flex" className="input-box">
                        <Form.Label>Phone Number</Form.Label>
                        <InputFormControl
                          name="phone"
                          placeholder="Enter Phone Number"
                          value={formData.phone}
                          handleChange={handleChange}
                          isInvalid={!!errors.phone}
                        />
                      </Box>
                      <p className="form_error"> {errors.phone}</p>
                    </Col>
                  </Row>
                </div>
                {isEdit && (
                  <div className="form-card mt-3">
                    <Box display="flex" alignItems="center">
                      <h5>Payment Details</h5>
                      <Button
                        className="add-project mt-2"
                        onClick={addExcelDetail}
                      >
                        <FaPlusCircle className="add-project-icon" size={15} />
                      </Button>
                    </Box>
                    {excelData &&
                      excelData?.length > 0 &&
                      excelData.map((excel, index) => (
                        <ExcelComponent
                          key={`invoiceData`}
                          expenseType={"organization-bank"}
                          getExcel={(file) => handleExcelFile(file, index)}
                          selectedFile={excel}
                          excelData={excelData}
                          handleExcelType={(type) =>
                            handleExcelType(type, index)
                          }
                          excelType={excel}
                          handleDeleteOnEdit={(key, spId) => {
                            handleDeleteExcelOnEdit(key, spId, index);
                          }}
                          handleDelete={() => {
                            handleDelete(index);
                          }}
                          isEditing={isEdit}
                          addNewExcelOnEdit={(file) => {
                            addNewExcelOnEdit(file, index);
                          }}
                          role={role}
                          editData={editData}
                        />
                      ))}
                    <Row>
                      <Col></Col>
                      <Col></Col>
                    </Row>
                  </div>
                )}
                <ModalFooter className="mt-3">
                  <SubmitButton
                    type="submit"
                    className="submit-btn"
                    handleClick={(e) => handleSubmit(e)}
                    btnTxt="Submit"
                  />
                </ModalFooter>
              </Form>
            </ModalBody>
          )}
        </ModalContent>
      </Modal>
    </>
  );
};

export default OrganizationBankForm;
